import { render, staticRenderFns } from "./PackageDown.vue?vue&type=template&id=2b7d9e20"
import script from "./PackageDown.vue?vue&type=script&lang=js"
export * from "./PackageDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports